import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type ZoomLevel = 100 | 110 | 120;

interface UIState {
  sidebarOpen: boolean;
  mobileSidebarOpen: boolean;
  theme: 'light' | 'dark';
  zoom: ZoomLevel;
  // Actions
  toggleSidebar: () => void;
  toggleMobileSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  setMobileSidebarOpen: (open: boolean) => void;
  setTheme: (theme: 'light' | 'dark') => void;
  setZoom: (zoom: ZoomLevel) => void;
  // Note: Use useToast() from @/components/ui/toast for notifications
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarOpen: true,
      mobileSidebarOpen: false,
      theme: 'light',
      zoom: 100,

      toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
      toggleMobileSidebar: () => set((state) => ({ mobileSidebarOpen: !state.mobileSidebarOpen })),
      setSidebarOpen: (open) => set({ sidebarOpen: open }),
      setMobileSidebarOpen: (open) => set({ mobileSidebarOpen: open }),
      setTheme: (theme) => set({ theme }),
      setZoom: (zoom) => set({ zoom }),
    }),
    {
      name: 'theme-storage',
      partialize: (state) => ({ theme: state.theme, zoom: state.zoom }),
    },
  ),
);
